export default {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  SCHEDULED: 'scheduled',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/announcements/announcement-types.js